var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('img',{staticClass:"mr-1",attrs:{"src":_vm.viewMapPic}}),_c('a',{attrs:{"href":_vm.mapLink,"target":"_blank"}},[_vm._v("View Map")])])
}
var staticRenderFns = []

export { render, staticRenderFns }